import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";

// Pages
import Home from "@/pages/Home";
import About from "@/pages/About";
import Portfolio from "@/pages/Portfolio";
import ProjectRequest from "@/pages/ProjectRequest";
import Appointment from "@/pages/Appointment";
import Flashs from "@/pages/Flashs";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Checkout from "@/pages/Checkout";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import LegalMentions from "@/pages/LegalMentions";
import Privacy from "@/pages/Privacy";
import Admin from "@/pages/Admin";
import StrassDentaire from "@/pages/StrassDentaire";

// Components
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";

function App() {
  return (
    <HelmetProvider>
      <div className="App min-h-screen flex flex-col">
        <div className="noise-overlay" />
        <BrowserRouter>
          <ScrollToTop />
          <Navbar />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/a-propos" element={<About />} />
              <Route path="/portfolio" element={<Portfolio />} />
              <Route path="/demande-projet" element={<ProjectRequest />} />
              <Route path="/rendez-vous" element={<Appointment />} />
              <Route path="/flashs" element={<Flashs />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/shop/:id" element={<ProductDetail />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/paiement-succes" element={<PaymentSuccess />} />
              <Route path="/paiement-annule" element={<PaymentCancel />} />
              <Route path="/mentions-legales" element={<LegalMentions />} />
              <Route path="/confidentialite" element={<Privacy />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/strass-dentaire" element={<StrassDentaire />} />
            </Routes>
          </main>
          <Footer />
        </BrowserRouter>
        <Toaster position="bottom-right" />
      </div>
    </HelmetProvider>
  );
}

export default App;
